import { useCommon } from '@/core/useCommon'
import { ROUTES } from '@/env/routes'
import { useMemo } from 'react'
import { SIDEBAR_MENU } from './constant'
import BetIcon from './assets/bet.svg'
import EnglishIcon from './assets/english.svg'
import InbitationIcon from './assets/inbitation.svg'
import MainIcon from './assets/main.svg'
import PlayerIcon from './assets/player.svg'
import Player1Icon from './assets/player1.svg'
import UpdateIcon from './assets/update.svg'
import { setUIState } from '@/ui/useUIStore'
import { Language, languageLabelMap } from '../lang/constant'
import { useUserStore } from '@/store/user/useUserStore'
import { useConfigStore } from '@/store/config/useConfigStore'
import { isDev } from '@/env'
import usePermissions from '../usePermissions'

// 側邊欄選單 hook
export const useSidebarMenu = () => {
  const { t, push, locale } = useCommon()
  const userInfo = useUserStore((state) => state.userInfo)
  const { isStation } = usePermissions()

  // 點擊選單後關閉側邊欄
  const withCloseSidebar = (cb: () => void) => {
    setUIState((prev) => {
      prev.sidebar = false
    })
    cb()
  }

  /** 選單 */
  const menusMap = useMemo(() => {
    const result: Record<SIDEBAR_MENU, OptionItem> = {
      // 個人中心
      [SIDEBAR_MENU.MAIN]: {
        key: SIDEBAR_MENU.MAIN,
        label: t('old:common.menuTitle.dashboard'),
        value: ROUTES.HOME(),
        onPress: () => withCloseSidebar(() => push(ROUTES.HOME())),
        icon: MainIcon,
      },
      // 直屬代理管理
      [SIDEBAR_MENU.AGENT_MANAGEMENT]: {
        key: SIDEBAR_MENU.AGENT_MANAGEMENT,
        label: !isStation ? t('old:agentList') : t('old:bigAgentList'),
        value: ROUTES.AGENT_MANAGEMENT(),
        onPress: () => withCloseSidebar(() => push(ROUTES.AGENT_MANAGEMENT())),
        icon: InbitationIcon,
        hidden: userInfo?.isBigAgent !== 1 && !isStation, // 如果不是大代理且也不是投注站，隐藏代理管理
      },
      // 直屬會員管理
      [SIDEBAR_MENU.PLAYER_MANAGEMENT]: {
        key: SIDEBAR_MENU.PLAYER_MANAGEMENT,
        label: t('old:vipList'),
        value: ROUTES.PLAYER_MANAGEMENT(),
        onPress: () => withCloseSidebar(() => push(ROUTES.PLAYER_MANAGEMENT())),
        icon: PlayerIcon,
        // hidden: codes && !codes?.includes(GAME_KEYS.SP),
      },
      // 邀請碼管理
      [SIDEBAR_MENU.INVITATION_CODE_GENERATOR]: {
        key: SIDEBAR_MENU.INVITATION_CODE_GENERATOR,
        label: t('old:userInviteTitle'),
        value: ROUTES.INVITATION_CODE_GENERATOR(),
        onPress: () => withCloseSidebar(() => push(ROUTES.INVITATION_CODE_GENERATOR())),
        icon: InbitationIcon,
      },
      // 投注站報表
      [SIDEBAR_MENU.STATION_REPORT]: {
        key: SIDEBAR_MENU.STATION_REPORT,
        label: t('old:stationReport'),
        value: ROUTES.STATION_REPORT(),
        onPress: () => withCloseSidebar(() => push(ROUTES.STATION_REPORT())),
        icon: InbitationIcon,
        hidden: !isStation,
      },
      // 代理報表
      [SIDEBAR_MENU.DELEGATE_REPORT]: {
        key: SIDEBAR_MENU.DELEGATE_REPORT,
        label: t('old:delegateReport'),
        value: ROUTES.DELEGATE_REPORT(),
        onPress: () => withCloseSidebar(() => push(ROUTES.DELEGATE_REPORT())),
        icon: InbitationIcon,
      },
      // 會員報表
      [SIDEBAR_MENU.PLAYER_REPORT]: {
        key: SIDEBAR_MENU.PLAYER_REPORT,
        label: t('old:vipDailyReport'),
        value: ROUTES.PLAYER_REPORT(),
        onPress: () => withCloseSidebar(() => push(ROUTES.PLAYER_REPORT())),
        icon: Player1Icon,
      },
      // 佣金報表
      [SIDEBAR_MENU.COMMISSION_REPORT]: {
        key: SIDEBAR_MENU.COMMISSION_REPORT,
        label: t('old:agentCommissionReport'),
        value: ROUTES.COMMISSION_REPORT(),
        onPress: () => withCloseSidebar(() => push(ROUTES.COMMISSION_REPORT())),
        icon: InbitationIcon,
        hidden: userInfo?.isBigAgent !== 1, // 代理账号无此页面
      },
      // 資金明細
      [SIDEBAR_MENU.FUNDS_DETAILS]: {
        key: SIDEBAR_MENU.FUNDS_DETAILS,
        label: t('old:funddetail'),
        value: ROUTES.FUNDS_DETAILS(),
        onPress: () => withCloseSidebar(() => push(ROUTES.FUNDS_DETAILS())),
        icon: InbitationIcon,
      },
      // 投注站兌換記錄
      [SIDEBAR_MENU.STATION_EXCHANGE_RECORD]: {
        key: SIDEBAR_MENU.STATION_EXCHANGE_RECORD,
        label: t('B857'),
        value: ROUTES.STATION_EXCHANGE_RECORD(),
        onPress: () => withCloseSidebar(() => push(ROUTES.STATION_EXCHANGE_RECORD())),
        icon: InbitationIcon,
        hidden: !isStation,
      },
      // 現金額度報表
      [SIDEBAR_MENU.STATION_QUOTA_CHANGE_LOG]: {
        key: SIDEBAR_MENU.STATION_QUOTA_CHANGE_LOG,
        label: t('old:cashQuotaReport'),
        value: ROUTES.STATION_QUOTA_CHANGE_LOG(),
        onPress: () => withCloseSidebar(() => push(ROUTES.STATION_QUOTA_CHANGE_LOG())),
        icon: InbitationIcon,
        hidden: !isStation,
      },
      // 充值記錄
      [SIDEBAR_MENU.RECHARGE_LIST]: {
        key: SIDEBAR_MENU.RECHARGE_LIST,
        label: t('old:rechargeRecord'),
        value: ROUTES.RECHARGE_LIST(),
        onPress: () => withCloseSidebar(() => push(ROUTES.RECHARGE_LIST())),
        icon: InbitationIcon,
        hidden: !isStation,
      },
      // 提現記錄
      [SIDEBAR_MENU.WITHDRAW_LIST]: {
        key: SIDEBAR_MENU.WITHDRAW_LIST,
        label: t('old:withdrawRecord'),
        value: ROUTES.WITHDRAW_LIST(),
        onPress: () => withCloseSidebar(() => push(ROUTES.WITHDRAW_LIST())),
        icon: InbitationIcon,
        hidden: !isStation,
      },
      // 實名驗證
      [SIDEBAR_MENU.KYC]: {
        key: SIDEBAR_MENU.KYC,
        label: t('old:kyc'),
        value: ROUTES.KYC(),
        onPress: () => withCloseSidebar(() => push(ROUTES.KYC())),
        icon: InbitationIcon,
        hidden: !isStation,
      },
      // 投注記錄
      [SIDEBAR_MENU.BET_RECORD]: {
        key: SIDEBAR_MENU.BET_RECORD,
        label: t('old:betRecord'),
        value: ROUTES.BET_RECORD(),
        onPress: () => withCloseSidebar(() => push(ROUTES.BET_RECORD())),
        icon: BetIcon,
      },
      // 子帳號管理
      [SIDEBAR_MENU.SUB_ACCOUNT_MANAGEMENT]: {
        key: SIDEBAR_MENU.SUB_ACCOUNT_MANAGEMENT,
        label: t('old:subAccount'),
        value: ROUTES.SUB_ACCOUNT_MANAGEMENT(),
        onPress: () => withCloseSidebar(() => push(ROUTES.SUB_ACCOUNT_MANAGEMENT())),
        icon: InbitationIcon,
        hidden: !isStation,
      },
      // 佣金提現
      [SIDEBAR_MENU.COMMISSION_WITHDRAWAL]: {
        key: SIDEBAR_MENU.COMMISSION_WITHDRAWAL,
        label: t('old:commissionDraw'),
        value: ROUTES.COMMISSION_WITHDRAWAL(),
        onPress: () => withCloseSidebar(() => push(ROUTES.COMMISSION_WITHDRAWAL())),
        icon: InbitationIcon,
        hidden: isStation, // 如果是投注站，隐藏佣金提现
      },
      // 密碼管理
      [SIDEBAR_MENU.UPDATE_PASSWORD]: {
        key: SIDEBAR_MENU.UPDATE_PASSWORD,
        label: t('old:pwdUpdateStep'),
        value: ROUTES.UPDATE_PASSWORD(),
        onPress: () => withCloseSidebar(() => push(ROUTES.UPDATE_PASSWORD())),
        icon: UpdateIcon,
      },
      // 投注站投注記錄
      [SIDEBAR_MENU.BETTING_BET_RECORD]: {
        key: SIDEBAR_MENU.BETTING_BET_RECORD,
        label: t('old:bettingBetRecord'),
        value: ROUTES.BETTING_BET_RECORD(),
        onPress: () => withCloseSidebar(() => push(ROUTES.BETTING_BET_RECORD())),
        icon: InbitationIcon,
        hidden: !isStation,
      },
      // 換語系
      [SIDEBAR_MENU.LANG]: {
        key: SIDEBAR_MENU.LANG,
        label: languageLabelMap.get(locale as Language) || '',
        value: 'lang',
        onPress: () => {},
        icon: EnglishIcon,
      },
    }

    return result
  }, [t, userInfo, isStation])

  return {
    menusMap, // 選單
    withCloseSidebar, // 點擊選單後關閉側邊欄
  }
}
